export default {
	open: 'Open',
	close: 'Close',
	share: 'Share on',
	languages: 'Languages',
	footer: {
		copyright: '© 2018 SMEUnited, All rights reserved',
		subscribe: 'Subscribe',
		thanks: 'Thank you for your subscription.'
	},
	contact: {
		name: 'Name',
		email: 'Email address',
		question: 'Message',
		subscribe: 'Submit question',
		thanks: 'Thanks for your message',
		smeunited: 'SMEunited',
		tellabel: 'Tel.: '
	},
	subscribe: {
		form: {
			firstname_label: 'First name',
			lastname_label: 'Last name',
			organisation_label: 'Organisation',
			email_label: 'Email address',
			privacy_label: 'I have read and accept the ',
			privacy_link: 'Privacy Policy',
			submit: 'Subscribe'
		},
		thanks: {
			title: 'Subscription complete',
			text: 'Thank you for subscribing to the newsletter.'
		}
	},
	error404: {
		title: 'Page not found',
		text:
			'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.',
		btn: 'Back to home'
	},
	cookies: {
		text: 'This website uses cookies to improve your browsing experience.',
		accept: 'Accept cookies',
		decline: 'Decline cookies'
	},
	about: {
		jobs: {
			title: 'Jobs',
			empty: 'There are currently no vacancies'
		}
	},
	articles: {
		readmore: 'Read more',
		morenews: 'More news',
		allnews: 'Show all news',
		latestnews: 'Latest news',
		relatedarticles: 'Related articles',
		relatednews: 'Related news',
		featured: 'Featured',
		news: 'News',
		positionpaper: 'Position Paper',
		tags: 'Tags',
		showmore: 'Show more articles',
		themes: 'Themes',
		publication: 'Related publication'
	},
	publications: {
		latestpublications: 'Latest publications',
		relatedpublications: 'Related publications',
		morepublications: 'More publications',
		allpublications: 'Show all publications',
		featured: 'Featured position paper',
		related: 'Related position paper',
		written: 'Written by',
		readmore: 'Read more',
		download: 'Download this paper',
		themes: 'Themes: ',
		tags: 'Tags: ',
		paper: 'Position paper',
		publication: 'Publication',
		filter: 'Filter by Theme(s) or Sector(s)'
	},
	events: {
		upcomingevents: 'Upcoming events',
		moreevents: 'More events',
		moreinfo: 'More info'
	},
	home: {
		subscribe: {
			title: 'Follow us',
			text:
				'Subscribe to our newsletter for the latest updates and position papers.',
			email: 'Email address',
			submit: 'Subscribe'
		},
		readmore: 'Read more',
		label: {
			news: 'News',
			press: 'Press Release',
			publication: 'Publication'
		},
		featuredpositionpaper: 'Featured position paper'
	},
	policies: {
		policies: 'Policies'
	},
	search: {
		term: 'Search',
		empty: 'Enter a search term above'
	},
	register: {
		title: 'Registration',
		subtitle1: 'Fields marked with ',
		subtitle2: ' are mandatory.',
		termlink: 'Privacy Policy',
		cta: 'Register now',
		field: {
			fname: 'First Name ',
			lname: 'Surname ',
			organization: 'Organisation ',
			email: 'E-mail address ',
			phone: 'Mobile phone number',
			phone_sub: ' (optional)',
			comments: 'Any comments?',
			lunch: 'I participate in the lunch:',
			dinner: 'I participate in the dinner:',
			dietary: 'Any dietary requirements?',
			dietary_sub: ' (Please specify)',
			participate: 'I will participate: ',
			proxy: 'Name of the proxy',
			proxy_sub: ' (if relevant)',
			persons: 'Accompanying Person(s)',
			persons_sub: ' (comma separated)',
			observer:
				'I propose the following observer to participate in the meeting',
			observer_sub: ' (indicate name)',
			term: 'I have read and accept the ',
			optin:
				'Subscribe to our newsletter for the latest updates and position papers.',
			mobile: 'Mobile number',
			mobile_required: 'Mobile number',
			attendance: 'Attendance:',
			attendance_required: 'Attendance:'
		},
		thanks: {
			title: 'Registration complete',
			thanks: 'Thank you for registering to the ',
			text:
				'We have received your registration for this event. You will shortly be receiving a confirmation email with the event details.'
		}
	}
}
